import { useImpersonation } from '@/contexts/ImpersonationContext';
import { Eye, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function ImpersonationBanner() {
  const { isImpersonating, impersonatedUserName, impersonatedUserRole, stopImpersonation } = useImpersonation();

  if (!isImpersonating) return null;

  return (
    <div className="bg-amber-500 text-amber-950 px-4 py-2 flex items-center justify-between gap-3 z-50 text-sm font-medium shrink-0">
      <div className="flex items-center gap-2">
        <Eye className="h-4 w-4" />
        <span>
          Visualizando como: <strong>{impersonatedUserName}</strong>
          {impersonatedUserRole && <span className="ml-1 opacity-80">({impersonatedUserRole})</span>}
        </span>
      </div>
      <Button
        variant="ghost"
        size="sm"
        onClick={stopImpersonation}
        className="h-7 px-2 text-amber-950 hover:bg-amber-600 hover:text-amber-950"
      >
        <X className="h-4 w-4 mr-1" />
        Sair
      </Button>
    </div>
  );
}
